import React from "react";
import { useHistory } from 'react-router-dom';

export default function AppSection() {
  const history = useHistory();
  return (
    <section className="bg-white px-4 sm:px-6 md:px-8 lg:px-12 xl:px-[175px] py-12 md:py-16 lg:py-20 xl:py-[60px]">
      <div className="max-w-[1200px] mx-auto">
        {/* Title Section */}
        <div className="text-center mb-8 md:mb-12 lg:mb-16 xl:mb-[60px]">
          <h2 className="font-bauhaus font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[42px] leading-tight lg:leading-[50px] xl:leading-[46px] text-[#C684F5] mb-4 md:mb-6 lg:mb-8 xl:mb-[24px]">
            Quer ajudar a fazer a diferença?
          </h2>
          <div className="max-w-[654px] mx-auto">
            <div className="font-raleway font-bold text-base sm:text-lg md:text-xl lg:text-2xl xl:text-[24px] leading-tight lg:leading-[30px] xl:leading-[28px] text-[#002342] flex items-center justify-center gap-2 sm:gap-3 md:gap-4">
              Use o nosso aplicativo como uma plataforma de doação e ganhe recompensas por fazer o bem
              <div className="w-[32px] h-[32px] sm:w-[36px] sm:h-[36px] md:w-[40px] md:h-[40px] lg:w-[42px] lg:h-[42px] bg-[#002342] rounded-full flex items-center justify-center flex-shrink-0">
<svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" viewBox="0 0 43 42" fill="none">
  <path d="M21.5 42C33.0979 42 42.5 32.5979 42.5 21C42.5 9.40201 33.0979 0 21.5 0C9.90201 0 0.5 9.40201 0.5 21C0.5 32.5979 9.90201 42 21.5 42Z" fill="#002342"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.4929 14.8427C19.3935 12.3884 15.8927 11.7282 13.2624 13.9756C10.6321 16.223 10.2618 19.9805 12.3274 22.6385C13.6504 24.341 17.0387 27.4979 19.3038 29.5479C20.0567 30.229 20.433 30.5696 20.8839 30.7063C21.2713 30.8237 21.7142 30.8237 22.1019 30.7063C22.5525 30.5696 22.9291 30.229 23.6817 29.5479C25.947 27.4979 29.3351 24.341 30.6583 22.6385C32.7239 19.9805 32.3988 16.1993 29.7232 13.9756C27.0476 11.7519 23.5922 12.3884 21.4929 14.8427Z" fill="#FAFAFA"/>
</svg>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content - 3 Columns Layout */}
        <div className="grid grid-cols-1">

          {/* Left Column - App Info */}
          <div className="order-2 lg:order-1 text-center lg:text-left">

            <div className="w-full  mt-6 md:mt-8 lg:mt-10 xl:mt-[40px] flex items-center justify-center">
              <img
                src="/assets/landing-2025/app-mockup-526d6e.png"
                alt="Magikk App Mockup"
                className="w-auto h-full  object-contain"
              />
            </div>
          </div>

        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button 
          onClick={() => window.open('https://apps.apple.com/br/app/magikk-goods-and-good-deeds/id1502548875')}
          className="bg-[#002342] text-white px-6 sm:px-8 md:px-10 lg:px-12 xl:px-[32px] py-3 sm:py-4 md:py-5 lg:py-6 xl:py-[16px] rounded-[20px] sm:rounded-[24px] md:rounded-[28px] lg:rounded-[30px] xl:rounded-[32px] font-raleway font-semibold text-sm sm:text-base md:text-lg lg:text-xl xl:text-[16px] hover:bg-[#85C4FF] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
            Baixe o APP
          </button>
        </div>
      </div>
    </section>
  );
}
